import React from 'react';
import { connect } from 'react-redux';
import { DefaultFooter } from 'enlm_ui_common';
import { getAccountData } from '../../../containers/AccountDetails/actions';
import { forwardTo } from '../../../utils/helper';

const Footer = props => {
  return <DefaultFooter {...props} forwardTo={forwardTo} />;
};

const mapDispatchToProps = dispatch => ({
  getAccountData: payload => dispatch(getAccountData(payload))
});

const mapStateToProps = state => ({
  locale: state.accountReducer.locale,
  companyId: state.appReducer.companyId,
  currentlySending: state.accountReducer.currentlySending,
  isQuotesExpanded: state.leadPreferenceReducer.isQuotesExpanded,
  version: state.appReducer.enlightenVersion,
  availableLocales: state.appReducer.availableLocales
});

export default connect(mapStateToProps, mapDispatchToProps)(Footer);
